"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.EclinicalWorks = void 0;
const helper_1 = require("../../helper");
const EmrConstants_1 = require("../../EmrConstants");
class EclinicalWorks {
    constructor() { }
    parse(pastedData, event, callbackEmit) {
        // eslint-disable-next-line no-param-reassign
        pastedData = pastedData.replace(/\r\n/g, "\n");
        try {
            const patientInfo = this.gettingPatientDetails(pastedData);
            const insurance = this.getInsurance(pastedData);
            //const contactDetails = this.getContactDetails(pastedData);
            const sendCallBackData = Object.assign(Object.assign({}, patientInfo), insurance);
            //@callback
            callbackEmit({ parseData: sendCallBackData });
        }
        catch (error) {
            //For Error logs
            callbackEmit({
                parseData: {},
                isDataParsed: 0,
                errorMessage: error ? error === null || error === void 0 ? void 0 : error.message : error,
                errorStack: error === null || error === void 0 ? void 0 : error.stack,
            });
        }
    }
    /**
     * @function gettingPatientDetails
     * @param sessionFirst {String}
     * @param sessionSecond {String}
     * @summary Getting Patient name, number, email, dob, address from Synergy
     */
    gettingPatientDetails(sessionFirst) {
        const Dob = (0, helper_1.substrInBetweenNew)(sessionFirst, "DOB", "|");
        return {
            patientInfo: Object.assign(Object.assign(Object.assign({}, this.patientName(sessionFirst)), this.patientPhoneNumberWithAddress(sessionFirst)), { dob: (0, helper_1.getDOB)(Dob, true) }),
        };
    }
    /**
     * @function getInsurance
     * @param sessionThird
     * @summary Getting Insurance from Synergy
     */
    getInsurance(sessionThird) {
        let insurance = (0, helper_1.substrInBetweenNew)(sessionThird, "Primary Insurance:", "Ethnicity");
        insurance = insurance.replace("\n", " ");
        return {
            insurance,
        };
    }
    /**
     * @function getPrimaryPhysician
     * @param data
     * @param sessionEight
     * @summary Getting Physician and Pharmacy from Synergy
     */
    getContactDetails(contactDetails) {
        const physiciansRaw = (0, helper_1.substrInBetweenInclusive)(contactDetails, "Physician NPI:", "Patient Demographics");
        const primaryPhy = {
            info: {
                physician: this.getPhysician(physiciansRaw),
                pharmacy: [],
                careGiver: [],
            },
        };
        //@Return
        return primaryPhy;
    }
    getPhysician(data) {
        const physicians = [];
        const physicianNameRaw = (0, helper_1.trim)((0, helper_1.substrInBetweenNew)(data, "Physician Name:", "Mobile Phone:"));
        const physicianNameParts = physicianNameRaw.split(",");
        const name = `Dr. ${physicianNameParts[1]} ${physicianNameParts[0]}`;
        const numbersRaw = (0, helper_1.substrInBetweenNew)(data, "Work Phone:", "Actions on Last Assessment");
        const phoneNo = (0, helper_1.changeNumberUSFormat)((0, helper_1.trim)(numbersRaw.replace(/[\s-()]/g, "")));
        if (name && phoneNo) {
            physicians.push({
                name,
                phoneNo,
                countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                sortOrder: 1,
            });
        }
        return physicians;
    }
    /**
     * @function getPharmacy
     * @param data
     */
    getPharmacy(data) {
        const pharmacies = [];
        const name = (0, helper_1.substrInBetweenNew)(data, "Pharmacy:", "\n");
        const phoneNoRaw = (0, helper_1.substrInBetweenNew)(data, "Work Phone:", "\n");
        const phoneNo = (0, helper_1.changeNumberUSFormat)((0, helper_1.trim)(phoneNoRaw.replace(/[\s-()]/g, "")));
        if (name && phoneNo) {
            pharmacies.push({
                name,
                phoneNo,
                countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                sortOrder: 1,
            });
        }
        return pharmacies;
    }
    getCaregiver(data) {
        var _a;
        const caregivers = [];
        const names = data.match(/\n[A-Z]+ [A-Z]+\n/g);
        const numbers = (_a = data.match(/\(\d\d\d\) \d\d\d-\d\d\d\d\n/g)) === null || _a === void 0 ? void 0 : _a.map(no => {
            return (0, helper_1.changeNumberUSFormat)((0, helper_1.trim)(no)
                .replace(/\s/, "")
                .replace(/[\s-()]/g, ""));
        });
        for (let i = 0; i < 2; i++) {
            caregivers.push({
                name: names === null || names === void 0 ? void 0 : names[i],
                phoneNo: numbers === null || numbers === void 0 ? void 0 : numbers[i],
                countryCode: EmrConstants_1.DEFAULT_COUNTRY_CODE,
                sortOrder: i + 1,
            });
        }
        return caregivers;
    }
    /**
     * @function patientPhoneNumberWithAddress
     * @param firstSession
     * @summary Patient number or Address both are same session
     */
    patientPhoneNumberWithAddress(firstSession) {
        const info = {
            phoneNo: "",
            address: {
                placeName: "",
                apartmentNo: "",
            },
        };
        const numbers = (0, helper_1.substrInBetweenNew)(firstSession, "Cell Phone:", "Sex:");
        const number = (0, helper_1.trim)(numbers.replace(/[\s-()]/g, ""));
        info.phoneNo = (0, helper_1.changeNumberUSFormat)(number);
        const addressString = (0, helper_1.substrInBetweenNew)(firstSession, "Self - patient is the\n" + "insured", "EMERGENCY CONTACTS");
        info.address.placeName = (0, helper_1.trim)(addressString);
        return info;
    }
    /**
     * @function patientName
     * @param sessionFirst {String}
     * @summary Getting Patient First name, Last name from string
     * @returns {name} FullName
     */
    patientName(sessionFirst) {
        var _a;
        const name = {
            firstName: "",
            lastName: "",
        };
        // @ts-ignore
        const nameCapturingRegex = /(?<last>.*),(?<first>.*) \d+Y/;
        const thirdLine = sessionFirst.split("\n")[2];
        const captured = (_a = thirdLine.match(nameCapturingRegex)) === null || _a === void 0 ? void 0 : _a.groups;
        name.firstName = (0, helper_1.trim)((captured === null || captured === void 0 ? void 0 : captured.first) || "");
        name.lastName = (0, helper_1.trim)((captured === null || captured === void 0 ? void 0 : captured.last) || "");
        return name;
    }
}
exports.EclinicalWorks = EclinicalWorks;
